// 平台类型,可用值:BsYq,PuHui,Zzb,Zyx
export const PLATFORM_TYPE = 'PuHui';
// export const PLATFORM_TYPE = 'BsYq'
// export const PLATFORM_TYPE = 'Zyx';
// export const PLATFORM_TYPE = 'Zzb';

// 查询平台, 0:播商友圈, 1:普惠
// export const PRODUCT_ENQUIRY = 0
export const PRODUCT_ENQUIRY = 1;
